<template>

</template>

<script>
    export default {
        created() {
            this.$store.dispatch('destroyToken')
                .then(response =>
                {
                    this.$store.commit('destroyToken')
                    window.location.href = "/#/login";
                }, (error) => {

                    this.$message({
                        message: 'Une erreur est survenue. Merci de relancer la page. Si le problème persiste, voir avec le pole WEB',
                        type: 'error',
                        center: true
                    });

                })
        }
    }
</script>
